import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    backdropContainer: 'p-6 -mx-6 space-y-2 md:py-10',
    contentContainer: 'z-1 flex items-center px-4 md:(pointer-events-none px-12 grid-area-stack)'
  }
} satisfies CMSConfig['bannerThin']
